import { FC } from "react";
import { useTranslation } from "react-i18next";
import SaleTabPane, { TabProps } from "../../../../components/TabPane";
import SDoc from "@/components/SDoc";
// import { SaleItemState } from "@/types/sales";
import PurchaseOrderList from "./components/PurchaseOrderList";
import { PurchaseOrderItem } from "@/types/purchase";

type CustomerTabType = 'doc'

const PurchaseOrderHome: FC = () => {
  const { t } = useTranslation();
  const TAB_LIST_KEY = "list"
  const TAB_DOC_KEY = "doc"

  const keyObj: (info: PurchaseOrderItem) => { [key in CustomerTabType]: TabProps } = (info) => ({
    doc: {
      key: TAB_DOC_KEY,
      label: (info.number) + ' ' + t('purchase.documents'),
      children: <SDoc docId={info.docId} />
    },
  })


  return <SaleTabPane<PurchaseOrderItem> defaultKey={TAB_LIST_KEY} defaultTabs={[
    {
      key: TAB_LIST_KEY,
      label: t("purchase.orderList"),
      children: <PurchaseOrderList />,
      closable: false,
    },
  ]} onOpens={(info) => keyObj(info)} />
}

export default PurchaseOrderHome;